import { atom } from 'recoil';

var IndexationStep;
(function (IndexationStep) {
    IndexationStep[IndexationStep["INITIAL"] = 0] = "INITIAL";
    IndexationStep[IndexationStep["IMPORT_ELEMENT_IN_WALL"] = 1] = "IMPORT_ELEMENT_IN_WALL";
    IndexationStep[IndexationStep["CREATE_USER_SELECTION"] = 2] = "CREATE_USER_SELECTION";
    IndexationStep[IndexationStep["ADD_MEDIA_IN_SELECTION"] = 3] = "ADD_MEDIA_IN_SELECTION";
    IndexationStep[IndexationStep["SEND_BULK_INDEXATION"] = 4] = "SEND_BULK_INDEXATION";
    IndexationStep[IndexationStep["CREATE_CLASSIFICATION"] = 5] = "CREATE_CLASSIFICATION";
    IndexationStep[IndexationStep["FINISHED"] = 6] = "FINISHED";
})(IndexationStep || (IndexationStep = {}));
var indexationAtom = atom({
    key: "IndexationAtom",
    "default": {
        step: IndexationStep.INITIAL,
        formFields: [],
        descriptorsHref: [],
        mediaIds: [],
        selectionId: "",
        error: false,
        hasRightError: false,
        needNewUploadErrors: [],
        mediaIdsAlreadyClassified: []
    }
});
var indexationProgressionAtom = atom({
    key: "IndexationProgressionAtom",
    "default": undefined
});

export { IndexationStep, indexationAtom, indexationProgressionAtom };
//# sourceMappingURL=atoms.js.map
